import React, { useState, useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";

import Swal from "sweetalert2";
import { useAppSelector } from "../../../hooks/hooks";
import { Navbar } from "../Navbar";
import { NavbarMobile } from "../NavbarMobile";
import { useNavigate, useParams } from "react-router-dom";
import landing_house from "../../../redux/reducers/landingReducer";
import { ModalEditName } from "../../../designs/modalEdit/ModalEditName";
import { ModalEditPrecioBase } from "../../../designs/modalEdit/ModalEditPrecioBase";
import { ModalEditCapacidades } from "../../../designs/modalEdit/ModalEditCapacidades";
import { ModalEditImageCarrousel } from "../../../designs/modalEdit/ModalEditImageCarrousel";
import { ModalEditDescripcion1 } from "../../../designs/modalEdit/ModalEditDescripcion1";
import { ModalEditDescripcion2 } from "../../../designs/modalEdit/ModalEditDescripcion2";
import { ModalEditRooms } from "../../../designs/modalEdit/ModalEditRooms";
import { ModalEditComforts } from "../../../designs/modalEdit/ModalEditComforts";
import { ModalEditEvents } from "../../../designs/modalEdit/ModalEditEvents";
import { ModalEditLocation } from "../../../designs/modalEdit/ModalEditLocation";
import { useDispatchDominio } from "../../../hooks/useDispatchDominio";
import { NavbarBroker } from "../../dashboardBroker/NavbarBroker";
import { NavbarMobileBroker } from "../../dashboardBroker/NavbarMobileBroker";

interface INITAL_STATE_TYPE {
    [key: string]: string;
}

export const ConfiguracionesBroker = () => {
    const navigate = useNavigate();
    const { plan, tema } = useAppSelector((state) => state.landing_house.house);
    const { tipo_usuario } = useAppSelector((state) => state.usuario_logeado);

    const corredor = useAppSelector((state) => state.corredor);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalName, setMondalName] = useState("");

    const ocultar = (titulo: string) => {
        const nombres = [
            "Personas adicionales",
            "Descuento por estadía",
            "descuento-estadia",
            "Cupones",
            "Disponibilidad máxima",
            "Conexiones externas",
        ];

        if (nombres.includes(titulo) && plan < 2) {
            return "hidden";
        } else {
            return "";
        }
    };
    console.log("plan", plan);

    const ocultarlanding = (titulo: string) => {
        const nombres = ["descripcion 2"];

        if (titulo === "descripcion 2" && tema !== "2") {
            return "hidden";
        } else if (titulo === "novedades" && plan < 2) {
            return "hidden";
        }
    };
    const opcionesPremiumLanding = (titulo: string) => {
        const nombres = ["descripcion 2", "novedades"];

        if (titulo === "descripcion 2" && tema !== "2") {
            return true;
        } else if (titulo === "novedades" && plan < 2) {
            return true;
        } else {
            return false;
        }
    };

    const opcionesPremium = (titulo: string) => {
        const nombres = [
            "descuento-estadia",
            "Cupones",
            "Disponibilidad máxima",
            "Conexiones externas",
        ];

        if (
            nombres.includes(titulo) &&
            ((tipo_usuario < 6 && plan < 2) ||
                (tipo_usuario === 6 && corredor.plan < 2))
        ) {
            return true;
        } else {
            return false;
        }
    };

    const OPCIONES = [
        {
            nombre: "Url",
            url: "url",
            icono: (
                <svg
                    id="Capa_2"
                    className="w-4 h-4 2xl:w-5 2xl:h-5"
                    data-name="Capa 2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 99.85 100"
                >
                    <g id="Testimonios">
                        <g>
                            <path
                                fill="#333333"
                                d="m99.85,26.15c-.45,2.49-1.02,4.95-2.11,7.26-1.25,2.64-2.95,4.95-5.01,7.01-6.82,6.82-13.64,13.64-20.45,20.46-4.33,4.34-9.51,6.7-15.68,7.06-6.88.4-12.67-1.9-17.57-6.6-1.89-1.82-2.59-4.1-1.85-6.68.72-2.54,2.46-4.08,5.01-4.65,2.4-.54,4.47.22,6.3,1.8,4.44,3.85,10.01,3.68,14.15-.45,6.92-6.9,13.85-13.79,20.74-20.72,4.94-4.97,3.53-13.12-2.72-16.01-3.7-1.71-8.11-.97-11.08,1.96-3.96,3.9-7.89,7.81-11.77,11.78-1.1,1.13-2.16,1.42-3.64.81-3.22-1.34-6.65-1.68-10.1-1.8-.82-.03-1.47-.28-1.8-1.07-.33-.78-.11-1.48.47-2.05,6.23-6.16,12.1-12.72,18.72-18.46,7.34-6.36,15.88-7.46,24.74-3.53,7.79,3.45,12.2,9.71,13.53,18.13.03.16.08.31.13.47v5.26Z"
                            />
                            <path
                                fill="#333333"
                                d="m20.54,100c-2.74-.53-5.45-1.19-7.93-2.54-7.03-3.83-11.27-9.69-12.36-17.62-1.06-7.67,1.35-14.31,6.76-19.8,6.88-6.98,13.85-13.89,20.78-20.82,4.5-4.5,9.96-6.92,16.31-7.01,6.78-.09,12.68,2.28,17.29,7.34,2.32,2.54,2.1,6.32-.18,8.78-2.21,2.39-6.17,2.75-8.91.79-.37-.26-.72-.56-1.05-.86-3.92-3.5-9.78-3.49-13.52.2-7.21,7.11-14.37,14.28-21.49,21.49-2.79,2.82-3.37,6.31-2.16,10.01,1.18,3.62,3.83,5.79,7.52,6.44,3.35.59,6.36-.32,8.82-2.8,3.91-3.94,7.87-7.83,11.75-11.8,1.06-1.09,2.09-1.34,3.48-.77,3.2,1.31,6.59,1.67,10,1.8.87.03,1.63.17,2.01,1.05.39.92-.02,1.63-.66,2.26-5.74,5.74-11.46,11.5-17.23,17.21-3.59,3.55-7.93,5.69-12.93,6.48-.22.04-.44.1-.65.16h-5.65Z"
                            />
                        </g>
                    </g>
                </svg>
            ),
        },

        {
            nombre: "Datos de facturación",
            url: "datos-facturacion",
            icono: (
                <svg
                    className="w-4 h-4 2xl:w-5 2xl:h-5"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    {" "}
                    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />{" "}
                    <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
                </svg>
            ),
        },

        {
            nombre: "Datos de Niubiz",
            url: "datos-niubiz",
            icono: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="w-4 h-4 2xl:w-5 2xl:h-5"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"
                    />
                </svg>
            ),
        },
    ];

    const render = () => {
        return (
            <div>
                <div className="w-full">
                    {modalName === "nombre" && modalVisible && (
                        <ModalEditName
                            modalVisible
                            setModalVisible={setModalVisible}
                        />
                    )}
                    {modalName === "precio" && modalVisible && (
                        <ModalEditPrecioBase
                            modalVisible
                            setModalVisible={setModalVisible}
                        />
                    )}
                    {modalName === "capacidades" && modalVisible && (
                        <ModalEditCapacidades
                            modalVisible
                            setModalVisible={setModalVisible}
                        />
                    )}
                    {modalName === "foto" && modalVisible && (
                        <ModalEditImageCarrousel
                            modalVisible
                            setModalVisible={setModalVisible}
                        />
                    )}
                    {modalName === "descripcion" && modalVisible && (
                        <ModalEditDescripcion1
                            modalVisibleComodidades={modalVisible}
                            setModalVisibleComodidades={setModalVisible}
                        />
                    )}
                    {modalName === "descripcion 2" && modalVisible && (
                        <ModalEditDescripcion2
                            modalVisibleDescripcion={modalVisible}
                            setModalVisibleDescripcion={setModalVisible}
                        />
                    )}
                    {modalName === "habitaciones" && modalVisible && (
                        <ModalEditRooms
                            modalVisibleRooms={modalVisible}
                            setModalVisibleRooms={setModalVisible}
                        />
                    )}
                    {modalName === "servicios" && modalVisible && (
                        <ModalEditComforts
                            modalVisibleComodidades={modalVisible}
                            setModalVisibleComodidades={setModalVisible}
                        />
                    )}
                    {modalName === "novedades" && modalVisible && (
                        <ModalEditEvents
                            modalVisibleEvents={modalVisible}
                            setModalVisibleEvents={setModalVisible}
                        />
                    )}
                    {modalName === "mapa" && modalVisible && (
                        <ModalEditLocation
                            modalVisibleLocation={modalVisible}
                            setModalVisibleLocation={setModalVisible}
                        />
                    )}

                    <div className="grid max-w-4xl grid-cols-2 gap-8 px-2 mx-auto mt-12 mb-10 text-sm xs:grid-cols-3 lg:grid-cols-4 2xl:text-base">
                        {OPCIONES.map((opcion, index) => {
                            return (
                                <div
                                    onClick={() =>
                                        !opcionesPremium(opcion.nombre) &&
                                        navigate(
                                            `/dashboard-corredor/configuraciones-corredor/${opcion.url}
                                            `,
                                        )
                                    }
                                    className={`  ${
                                        opcionesPremium(opcion.nombre)
                                            ? "cursor-not-allowed bg-slate-50"
                                            : "bg-[#FAFAFA] hover:scale-105 cursor-pointer"
                                    } border  pb-12 pt-4 px-6 rounded-lg shadow-md relative `}
                                    key={index}
                                >
                                    <p>{opcion.nombre} </p>
                                    {opcionesPremium(opcion.nombre) && (
                                        <div className="absolute bottom-4 left-4">
                                            <span className="text-[10px] border border-orange-500 text-orange-500  p-[2px] rounded-md">
                                                Estándar
                                            </span>
                                        </div>
                                    )}
                                    <div className="absolute bottom-4 right-4">
                                        <p className="">{opcion.icono}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    };
    return (
        <>
            {tipo_usuario === 3 || tipo_usuario === 4 ? (
                <Navbar titulo="Configuraciones">
                    {render()}
                    <NavbarMobile />
                </Navbar>
            ) : (
                <NavbarBroker titulo="Configuraciones">
                    {render()}
                    <NavbarMobileBroker />
                </NavbarBroker>
            )}
        </>
    );
};
